import axios from "../../../../api/axios";
import { User, PaginatedResponse } from "../../../../types/types";

export const getEntityFollowers = async (entityId: string, params?: string): Promise<PaginatedResponse<User>> => {
  try {
    const response = await axios.get(`/football-entities/${entityId}/followers${params || ""}`);
    return response.data.data;
  } catch (error) {
    throw new Error(`Failed to fetch entity followers: ${error}`);
  }
};

export const getEntityFollowing = async (entityId: string, params?: string): Promise<PaginatedResponse<User>> => {
  try {
    const response = await axios.get(`/football-entities/${entityId}/following${params || ""}`);
    return response.data.data;
  } catch (error) {
    throw new Error(`Failed to fetch entity following: ${error}`);
  }
};
